module.exports = __webpack_public_path__ + "static/media/water-drop.cf6e5a1d.svg";